/** Toast/Snackbar host (06 §4.19) — bottom-center transient feedback. */
import { useUiStore } from '../../stores/uiStore';
import styles from './Toaster.module.css';

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  if (toasts.length === 0) return null;
  return (
    <div className={styles.host} role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={styles.toast}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
